import s from "./RatingRow.module.css";
import { StarGroup } from "./StarGroup";

interface RatingRowProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

export const RatingRow = ({
  label,
  value,
  onChange,
  disabled = false,
}: RatingRowProps) => (
  <div className={s.row} data-testid={`feedback-rating-${label}`}>
    <span className={s.label}>{label}</span>
    <StarGroup
      label={label}
      value={value}
      onChange={onChange}
      disabled={disabled}
    />
  </div>
);
